import axios from 'axios';

/**
 * Get dashboard statistics
 * @returns Promise<Object>
 */
export async function getDashboardStats() {
  try {
    // Try to get statistics from the public API
    const statsResponse = await axios.get('/api/statistics');
    const publicStats = statsResponse.data;

    // Mock data for charts (in a real app, you'd fetch this from an API)
    const userGrowth = [
      { label: 'Jan', value: 120 },
      { label: 'Feb', value: 150 },
      { label: 'Mar', value: 180 },
      { label: 'Apr', value: 200 },
      { label: 'May', value: 230 },
      { label: 'Jun', value: 250 },
    ];

    const messageActivity = [
      { label: 'Mon', value: 45 },
      { label: 'Tue', value: 52 },
      { label: 'Wed', value: 38 },
      { label: 'Thu', value: 61 },
      { label: 'Fri', value: 55 },
      { label: 'Sat', value: 48 },
      { label: 'Sun', value: 42 },
    ];

    const userDistribution = [
      { label: 'Active', value: publicStats.total || 1000 },
      {
        label: 'Inactive',
        value: Math.floor((publicStats.total || 1000) * 0.3),
      },
      { label: 'New', value: Math.floor((publicStats.total || 1000) * 0.1) },
    ];

    return {
      totalUsers: publicStats.total || 0,
      activeUsers: Math.floor((publicStats.total || 0) * 0.7),
      totalMessages: 0, // This would come from a messages API
      totalThreads: 0, // This would come from a threads API
      userGrowth,
      messageActivity,
      userDistribution,
      ...publicStats,
    };
  } catch (error) {
    /* eslint-disable no-console */
    console.log(error);
    // Return mock data if API fails
    return {
      totalUsers: 0,
      activeUsers: 0,
      totalMessages: 0,
      totalThreads: 0,
      userGrowth: [
        { label: 'Jan', value: 0 },
        { label: 'Feb', value: 0 },
        { label: 'Mar', value: 0 },
        { label: 'Apr', value: 0 },
        { label: 'May', value: 0 },
        { label: 'Jun', value: 0 },
      ],
      messageActivity: [
        { label: 'Mon', value: 0 },
        { label: 'Tue', value: 0 },
        { label: 'Wed', value: 0 },
        { label: 'Thu', value: 0 },
        { label: 'Fri', value: 0 },
        { label: 'Sat', value: 0 },
        { label: 'Sun', value: 0 },
      ],
      userDistribution: [
        { label: 'Active', value: 0 },
        { label: 'Inactive', value: 0 },
        { label: 'New', value: 0 },
      ],
    };
  }
}
